module.exports = __webpack_public_path__ + "img/support.4caa5ce9.svg";